module.exports = __webpack_public_path__ + "img/logo2_2.93c42b63.png";